app.directive("customDropdown", ["$document", function ($document) {
	return {
		restrict: "E",
		scope: {
			items: "=", // array of {name, value}
			ngModel: "=", // selected item value
			onAction: "&", // callback when button clicked
			label: "@", // label
			clinician: "=",
			setProcedure: "&",
		},
		templateUrl: "app/src/js/components/customDropdown/custom-dropdown.html",
		controller: ["$scope", "$element", function ($scope, $element) {
			$scope.isOpen = false;

			$scope.isDisabled = false;

			$scope.toggleState = function () {
				if ($scope.isDisabled) return;
				$scope.isDisabled = true;
				$scope.toggle();
			};

			$scope.selectItem = function (item) {
				$scope.ngModel = item.value;
				$scope.isOpen = false;
				$scope.isDisabled = false;
				$scope.setProcedure({
					form: {
						diagnosis: item.value.primary_procedure.pt.term,
						diagnosis_object: item.value.primary_procedure,
						isFavourite: true,
						primary_procedure: item.value.primary_procedure,
						secondary_procedure_list: item.value.secondary_procedure_list ?? [],
					}
				});
			};

			$scope.getSelectedItem = function () {
				return ($scope.items || []).find((i) => i.value === $scope.ngModel);
			};

			$scope.toggle = function () {
				$scope.isOpen = !$scope.isOpen;
			};

			$scope.handleAction = function (item, $event) {
				$event.stopPropagation();
				$scope.onAction({ item: item });
				$scope.isOpen = false;
				$scope.isDisabled = false;
			};

			$scope.renderSecondaryList = (array) => (array || []).map((item) => item.pt.term).join(", ");

			// ----------------------------
			// CLICK OUTSIDE TO CLOSE
			// ----------------------------
			const clickHandler = function (event) {
				// If click is outside this directive element → close dropdown.
				if (!$element[0].contains(event.target)) {
					$scope.$evalAsync(() => {
						$scope.isOpen = false;
						$scope.isDisabled = false;
					});
				}
			};

			// Bind document click
			$document.on("click", clickHandler);

			// Clean up when directive is destroyed
			$scope.$on("$destroy", function () {
				$document.off("click", clickHandler);
			});
		}],
	};
}]);
